import { State } from 'state'
import { checkErrorExist } from 'components/utils'
import { SET_UP_ERRORS, COMPLETE_SET_UP_ERRORS, CREATE_TASKS_ERRORS, PAYMENT_ERRORS } from './constants'
import _ from 'lodash'

export const selectSectionErrors = (state: State): { [key: string]: boolean } => {
    const returnErrors: { [key: string]: boolean } = {
        setUpErrors: false,
        tasksErrors: false,
        completeErrors: false,
        paymentErrors: false,
    }
    const registrationKey = 'registration'
    const errors = state.errors.campaignEditor
    returnErrors.setUpErrors =
        checkErrorExist(Object.values(SET_UP_ERRORS), errors) ||
        (errors[registrationKey] && errors[registrationKey].max_slots)
    returnErrors.completeErrors = checkErrorExist(Object.values(COMPLETE_SET_UP_ERRORS), errors)
    returnErrors.paymentErrors = checkErrorExist(Object.values(PAYMENT_ERRORS), errors)
    const registrationErrors = { ...errors[registrationKey] }
    delete registrationErrors['max_slots']
    returnErrors.tasksErrors =
        checkErrorExist(Object.values(CREATE_TASKS_ERRORS), errors) || !_.isEmpty(registrationErrors)
    return returnErrors
}
export const selectTaskErrors =
    (uuid: string) =>
    (state: State): Record<string, any> | null => {
        if (uuid && state.errors.campaignEditor.tasks) {
            return state.errors.campaignEditor.tasks[uuid]
        } else return null
    }
